import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatingPrakritiButton from '../common/FloatingPrakritiButton';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
      <FloatingPrakritiButton />
    </div>
  );
};

export default Layout;